import { render, staticRenderFns } from "./BottomPopupMenu.vue?vue&type=template&id=3efd5930&scoped=true&"
import script from "./BottomPopupMenu.vue?vue&type=script&lang=js&"
export * from "./BottomPopupMenu.vue?vue&type=script&lang=js&"
import style0 from "./BottomPopupMenu.vue?vue&type=style&index=0&id=3efd5930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd5930",
  null
  
)

export default component.exports